import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store, { persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./ErrorBoundaryProps";
import { initI18n } from "./i18n/i18n";
import { initializeConsoleWrapper } from "./utils/appInsights";

import { BrowserRouter as Router } from "react-router-dom";
import Auth0ProviderConfig from "./auth0-integration/Auth0Provider";

const LoadingUI = (
  <div className="flex h-screen items-center justify-center">
    <div className="text-sm opacity-70">Loading translations…</div>
  </div>
);

(async () => {
  // Initialize Application Insights console wrapper first
  // This ensures all console logs are captured and sent to Application Insights
  initializeConsoleWrapper();

  await initI18n();
  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

  root.render(
    <React.StrictMode>
      <Router>
        <Auth0ProviderConfig>
          <ErrorBoundary>
            <Provider store={store}>
              <PersistGate
                loading={<div className="flex justify-center items-center p-8"><img src="/brand/mark-light.svg" alt="" className="w-8 h-8" /></div>}
                persistor={persistor}
              >
                <Suspense fallback={LoadingUI}>
                  <App />
                </Suspense>
              </PersistGate>
            </Provider>
          </ErrorBoundary>
        </Auth0ProviderConfig>
      </Router>
    </React.StrictMode>
  );
})();

reportWebVitals();
